module.exports = __webpack_public_path__ + "img/invite-tenders.2f580837.png";